import zod from "zod";

export const uuid = zod.string().uuid();
export const date = zod.string().date();
export const url = zod.string().url(); 
export const optionSchema = zod.object({ label: zod.string(), value: zod.unknown() });